// Dropdown Description.
$(document).ready(function(){
  // $('.description-product__accordion-list > li').first().addClass('active_description');
  $('.description-product__accordion-list > li > .description-product__answer').hide();
  $('.description-product__accordion-list > li.active_description > .description-product__answer').show();
  $('.description-product__accordion-list > li > h3').click(function() {
    var $open_description = $(this).parents('li');
    if ($($open_description).hasClass("active_description")) {
      $($open_description).removeClass("active_description").find(".description-product__answer").slideUp();
    } else {
      $(".description-product__accordion-list > li.active_description .description-product__answer").slideUp();
      $(".description-product__accordion-list > li.active_description").removeClass("active_description");
      $($open_description).addClass("active_description").find(".description-product__answer").slideDown();
    }
    return false;
  });
});